export const closeImagePlayer = () => ({
  type: 'CLOSE_IMAGEPLAYER',
  isVisible: false,
});

export const openImagePlayer = () => ({
  type: 'OPEN_IMAGEPLAYER',
  isVisible: true,
});

export const setImagePlayerImages = imagePlayerImages => ({
  type: 'SET_IMAGEPLAYER_IMAGES',
  imagePlayerImages,
});

export const setInitialIndex = initialIndex => ({
  type: 'SET_INITIAL_INDEX',
  initialIndex,
});



// WEBPACK FOOTER //
// ./frontend/js/Base/Actions/imagePlayerActions.jsx